import { logXandrAction } from '@/api'
import { getAllDatasetsRootFamilyFromQuery } from '@/common/U'

const module = 'XANDR_WORKBENCH_ACTIONS_'
export const STORE_NAME = 'xandr_workbench'

export const SET_INTERFACE = module + 'SET_INTERFACE'
export const SEND_DOWN_STREAM = module + 'SEND_DOWN_STREAM'
export const SET_ENABLE_UPDATE_INSIGHTS = module + 'SET_ENABLE_UPDATE_INSIGHTS'
export const SET_ENABLE_UPDATE_TARGET_HEADER_DATA = module + 'SET_ENABLE_UPDATE_TARGET_HEADER_DATA'
export const SHOW_UE_MODAL = module + 'SHOW_UE_MODAL'
export const SET_LOADING_INSIGHTS = module + 'SET_LOADING_INSIGHTS'
export const LOG_XANDR_ACTION = module + 'LOG_XANDR_ACTION'
export const TOGGLE_MOCK_DATA = module + 'TOGGLE_MOCK_DATA'
export const SET_QUERY = module + 'SET_QUERY'
export const RESET = module + 'RESET'
export const SHOW_SAVING_LIVE_DIGITAL_PROMPT = 'SHOW_SAVING_LIVE_DIGITAL_PROMPT'
export const SET_CONTROL_URL = 'SET_CONTROL_URL'
export const SET_QUERY_ERRORED_OUT = module + 'SET_QUERY_ERRORED_OUT'
export const SET_TRAITS = module + 'SET_TRAITS'
export const SHOW_MODELING_MODAL = module + 'SHOW_MODELING_MODAL'
export const SET_AUDIENCE_EXPANSION = module + 'SET_AUDIENCE_EXPANSION'
export const SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE = module + 'SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE'
export const CONFIGURE_AUDIENCE_EXPANSION = module + 'CONFIGURE_AUDIENCE_EXPANSION'

const actions = {
  [SHOW_MODELING_MODAL]: (context) => {
    context.commit(SHOW_MODELING_MODAL)
  },
  [SET_INTERFACE]: (context, inter) => {
    context.commit(SET_INTERFACE, inter)
  },
  // this is the Xandr Send Downstream created for the purpose of the
  [SEND_DOWN_STREAM]: (context) => {
    context.state.interface.__sendDownStream({
      context,
      targetId: context.getters.newWorkbenchTarget.id
    })
  },
  [SET_ENABLE_UPDATE_INSIGHTS]: (context, setValue) => {
    context.commit(SET_ENABLE_UPDATE_INSIGHTS, setValue)
  },
  [SET_ENABLE_UPDATE_TARGET_HEADER_DATA]: (context, setValue) => {
    context.commit(SET_ENABLE_UPDATE_TARGET_HEADER_DATA, setValue)
  },
  [SHOW_UE_MODAL]: (context) => {
    context.commit(SHOW_UE_MODAL)
  },
  [SHOW_SAVING_LIVE_DIGITAL_PROMPT]: (context) => {
    context.commit(SHOW_SAVING_LIVE_DIGITAL_PROMPT)
  },
  [SET_LOADING_INSIGHTS]: (context, value) => {
    context.commit(SET_LOADING_INSIGHTS, value)
  },
  [TOGGLE_MOCK_DATA]: (context, value) => {
    context.commit(TOGGLE_MOCK_DATA, value)
  },
  [SET_QUERY]: (context, value) => {
    context.commit(SET_QUERY, value)
  },
  [RESET]: (context) => {
    context.commit(RESET)
  },
  [LOG_XANDR_ACTION]: async (context, value) => {
    await logXandrAction(value)
    context.commit(LOG_XANDR_ACTION, value)
  },
  [SET_QUERY_ERRORED_OUT]: (context, value) => {
    context.commit(SET_QUERY_ERRORED_OUT, value)
  },
  [SET_AUDIENCE_EXPANSION]: (context, value) => {
    context.commit(SET_AUDIENCE_EXPANSION, value)
  },
  [SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE]: (context, value) => {
    context.commit(SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE, value)
  },
  [CONFIGURE_AUDIENCE_EXPANSION]: (context, targetDefinition) => {
    // Extract unique rootFamily values from target definition
    const uniqueRootFamilies = getAllDatasetsRootFamilyFromQuery(targetDefinition || [])

    // Get sourceConstants from root store
    const sourceConstants = context.rootGetters.getConstants
    const audienceExpansionConfig = sourceConstants && sourceConstants.AUDIENCE_EXPANSION ? sourceConstants.AUDIENCE_EXPANSION : {}
    const C360Datasources = context.rootGetters.getC360Datasources

    let audienceExpansionValue = false
    let allowToggle = false

    // Helper function to find datasource key by rootFamily value
    const findDatasourceKeyByRootFamily = (datasources, rootFamily) => {
      if (!datasources) return 'DEFAULT'

      for (const datasourceKey in datasources) {
        if (datasources[datasourceKey] === rootFamily) {
          return datasourceKey
        }
      }
      return 'DEFAULT'
    }

    if (uniqueRootFamilies.length === 0) {
      // No rootFamily values found, use DEFAULT
      const defaultConfig = audienceExpansionConfig.DEFAULT || { default: true, allowToggle: false }
      audienceExpansionValue = defaultConfig.default
      allowToggle = defaultConfig.allowToggle
    } else if (uniqueRootFamilies.length === 1) {
      // Single rootFamily: use its specific configuration
      const datasourceKey = findDatasourceKeyByRootFamily(C360Datasources, uniqueRootFamilies[0])
      const datasourceConfig = audienceExpansionConfig[datasourceKey] || audienceExpansionConfig.DEFAULT || { default: true, allowToggle: false }
      audienceExpansionValue = datasourceConfig.default
      allowToggle = datasourceConfig.allowToggle
    } else {
      // Multiple rootFamilies: always use DEFAULT configuration
      const defaultConfig = audienceExpansionConfig.DEFAULT || { default: true, allowToggle: false }
      audienceExpansionValue = defaultConfig.default
      allowToggle = defaultConfig.allowToggle
    }

    // Update Vuex state with the determined values
    context.dispatch(SET_AUDIENCE_EXPANSION, audienceExpansionValue)
    context.dispatch(SET_ALLOW_AUDIENCE_EXPANSION_TOGGLE, allowToggle)

    return {
      uniqueRootFamilies,
      audienceExpansionValue,
      allowToggle
    }
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/Xandr/store/actions.js